import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "editStaffView__content" }
const _hoisted_2 = { class: "editStaffView__formBlock" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "editStaffView__formBlock" }
const _hoisted_5 = { class: "editStaffView__formBlock" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "label-with-required" }, "员工额度", -1)
const _hoisted_7 = { class: "editStaffView__formBlock" }
const _hoisted_8 = { class: "fl-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_tree_select = _resolveComponent("a-tree-select")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_app_section = _resolveComponent("app-section")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { class: "utils__pageContainer editStaffView__wrap" }, {
    title: _withCtx(() => [
      _createVNode(_component_router_link, {
        class: "link-goback",
        to: {name: 'main.staff.list'}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_app_icon, { type: "arrow-left" })
        ]),
        _: 1
      }, 8, ["to"]),
      _createTextVNode(" 编辑员工 ")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_form, {
          ref: "formRef",
          class: "editStaffView__form",
          model: _ctx.formData,
          "label-col": _ctx.labelCol,
          "wrapper-col": _ctx.wrapperCol,
          rules: _ctx.rules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_app_section, { title: "员工基本信息" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_a_form_item, {
                    label: "姓名",
                    required: "",
                    name: "userName"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.formData.userName,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.userName) = $event)),
                        "allow-clear": ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "手机号码",
                    required: "",
                    name: "phone"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(_ctx.formData.phone), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "工号" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.formData.jobNumber,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.jobNumber) = $event)),
                        "allow-clear": ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "部门" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_tree_select, {
                        value: _ctx.formData.departmentId,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.departmentId) = $event)),
                        style: {"width":"100%"},
                        "allow-clear": "",
                        "show-line": true,
                        "tree-data": _ctx.departmentTree,
                        "search-placeholder": "请选择"
                      }, null, 8, ["value", "tree-data"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "角色",
                    name: "roleId"
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.isInit)
                        ? (_openBlock(), _createBlock(_component_a_select, {
                            key: 0,
                            value: _ctx.formData.roleId,
                            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.roleId) = $event)),
                            mode: "multiple",
                            style: {"width":"100%"},
                            placeholder: "请选择角色"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roleList, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  key: item.roleId,
                                  value: item.roleId,
                                  disabled: item.initStatus === 'INIT'
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.roleName), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value", "disabled"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_3, "初始管理员"))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "员工状态",
                    help: "离职后，该员工账户余额自动全部回收"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio_group, {
                        value: _ctx.formData.state,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.state) = $event)),
                        options: _ctx.stateOptions
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            false
              ? (_openBlock(), _createBlock(_component_app_section, {
                  key: 0,
                  title: "员工车辆信息"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_a_form_item, { label: "绑定车辆" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: _ctx.formData.vehicleId,
                            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.vehicleId) = $event)),
                            mode: "multiple",
                            style: {"width":"100%"},
                            placeholder: "请选择车辆"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.autoList, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  key: item.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.licensePlate), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_app_section, { title: "企业支付信息" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_a_form_item, { label: "企业支付" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_switch, {
                        checked: _ctx.formData.enterprisePay,
                        "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.enterprisePay) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  _withDirectives(_createVNode(_component_a_form_item, { name: "finiteAmount" }, {
                    label: _withCtx(() => [
                      _hoisted_6
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio_group, {
                        value: _ctx.formData.restrictState,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.restrictState) = $event)),
                        options: _ctx.restrictStateOptions
                      }, null, 8, ["value", "options"]),
                      _withDirectives(_createElementVNode("span", null, [
                        _createTextVNode(" 每月："),
                        _createVNode(_component_a_input, {
                          value: _ctx.formData.finiteAmount,
                          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.finiteAmount) = $event)),
                          type: "number",
                          placeholder: "请输入整数金额",
                          suffix: "元",
                          style: {"width":"170px"}
                        }, null, 8, ["value"])
                      ], 512), [
                        [_vShow, _ctx.formData.restrictState === 'FINITE']
                      ])
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, _ctx.formData.enterprisePay]
                  ]),
                  _withDirectives(_createVNode(_component_a_form_item, { label: "加油制度" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: _ctx.formData.ruleId,
                        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.ruleId) = $event)),
                        placeholder: "请选择用户制度",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select_option, { value: "" }, {
                            default: _withCtx(() => [
                              _createTextVNode("无制度")
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sceneList, (item) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: item.id,
                              value: item.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.ruleName), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, _ctx.formData.enterprisePay]
                  ])
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_a_form_item, { "wrapper-col": { span: 14, offset: 5 } }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      disable: _ctx.submiting,
                      loading: _ctx.submiting,
                      onClick: _ctx.onSubmit
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("保存")
                      ]),
                      _: 1
                    }, 8, ["disable", "loading", "onClick"]),
                    _createVNode(_component_router_link, {
                      class: "ant-btn",
                      to: { name: 'main.staff.list' },
                      style: {"margin-left":"15px"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("取消")
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["model", "label-col", "wrapper-col", "rules"])
      ])
    ]),
    _: 1
  }))
}